import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Prompt } from "react-router-dom";
import {
  Box,
  Card,
  TextField,
  Typography,
  Link as MuiLink,
  CardContent,
  Grid,
  makeStyles,
  Theme,
  Switch,
  Divider,
  Checkbox,
  Button,
} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import EditIcon from "@material-ui/icons/Edit";
import { Check, Close } from "@material-ui/icons";
import { GridRowModel } from "@mui/x-data-grid-pro";
import { useFormik } from "formik";
import moment from "moment";
import "moment-timezone";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import NewCommonButton from "src/components/CommonButton/NewCommonButton";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";

import TabHeader from "src/components/TabHeader/TabHeader";
import { OthersRoute } from "../../others.routes";
import { columns } from "./components/columns";
import { searchData } from "src/app-redux/common-actions";
import * as Yup from "yup";
import { getVehicleDetailsByIdAction } from "src/app-redux/vehicle/actions/vehicleActions";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { useAppSelector } from "src/app-redux/hooks";
import CommonSelect from "src/components/molecules/CommonSelect";
import { SelectChangeEvent, Tooltip } from "@mui/material";
import { customColorCodeList, filteryByArr } from "src/common/utils/app.dropdowns";
import { createWebocInfo, updateWebocInfo } from "src/app-redux/customs/actions/customsActions";
import { loader } from "src/app-redux/customs/customsSlice";
import Drawer from "./components/Drawer";
import { filterBy } from "src/common/utils/helpers";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import CommonLoader from "src/components/Loader/CommonLoader";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    minHeight: 500,
    "& .MuiDataGrid-columnHeaderWrapper": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    "& .MuiDataGrid-columnHeaderWrapper .MuiIconButton-label svg": { color: "rgba(255,255,255,1)" },
  },
  cardMain: {
    marginBottom: "0px",
    paddingTop: "2px",
    width: "calc(100%)",
  },
  pageHeading: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightRegular,
    color: "#000",
  },
  breadcrumbs: {
    fontSize: theme.typography.pxToRem(12),
  },
  button: {
    margin: theme.spacing(1),
  },
  hideDatesGrid: {
    display: "none",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
}));

interface Props {}

export function WebocInfo({}: Props): React.ReactElement {
  const classes = useStyles();
  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const [moduleName, setmoduleName] = useState<any>(OthersRoute.title);
  const [vehicleRecord, setvehicleRecord] = React.useState<GridRowModel[]>([]);
  const [pageHeading, setpageHeading] = useState<any>("WeBOC Information");
  const [loader2, setLoader] = useState<any>(false);
  const [isCustomDate, setIsCustomDate] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [vehicleRegNumberArr, setvehicleRegNumberArr] = React.useState<any[]>([]);
  const [vehicleNumber, setVehicleNumber] = useState<any>("");
  const [isEditMode, setisEditMode] = React.useState<boolean>(false);
  const loading = useAppSelector(loader);
  let vehicleRegArr: any[] = [];
  const [vehicleNumberLength, setVehicleNumberLength] = useState<number>(0);
  const startDatePickerRef: any = useRef(null);
  const endDatePickerRef: any = useRef(null);

  /* AXIOS Calls */
  const getVehicleStatus = async (gatePassId: number) => {
    const res: any = await dispatch(getVehicleDetailsByIdAction(gatePassId));
    if (res.payload && res.payload.vehicleDetail) {
      formik.setFieldValue("weBocId", res.payload.vehicleDetail.webBocId ?? "");
      formik.setFieldValue(
        "webocRMSColorCode",
        res.payload.vehicleDetail.vehicleCustomColorCode ?? 1
      );
      formik.setFieldValue("gatePassId", res.payload.vehicleDetail.gateEntryId);
      formik.setFieldValue("vehicleCleared", res.payload.vehicleDetail.vehicleCleared);
      formik.setFieldValue("gdNo", res.payload.vehicleDetail.gdNo);
      // formik.setFieldValue("inspectorComments", res.payload.vehicleDetail.inspectorComments);
      formik.setFieldValue("yardSlotInfo", res.payload.vehicleDetail.yardSlotInfo);
    }
    if (res.payload && res.payload.allotedYardDetails) {
      formik.setFieldValue(
        "yardSlotInfo",
        `${res.payload.allotedYardDetails.yardName}, Row ${res.payload.allotedYardDetails.rowName}, Slot ${res.payload.allotedYardDetails.slotNumber}` ??
          ""
      );
    }
  };
  const getVehicleInfoByVehicleId = async (id: number, title: string) => {
    let results: any = [];
    try {
      setLoader(true);
      // Add API here
      results = await fetchWrapper.get(`get-vehicle-status-id-by-vehicle-Id/${id}`);
      if (results.isSuccess == true) {
        setValues({
          ...values,
          vehicleStatusId: results.value.vehicleStatusId,
          registrationNumber: title,
          terminalLocationId: results.value.terminalLocationId,
        });
      }
      setLoader(false);
      return;
    } catch (error: any) {
      setLoader(false);
    }
  };
  const getVehicleByRegistrationNo = async (queryString: string) => {
    formik.setFieldValue("weBocId", "");
    formik.setFieldValue("webocRMSColorCode", 1);
    let results: any = [];
    // setLoader(true);
    results = await fetchWrapper.get(
      `search-vehicles-by-vehicle-registration-number/${queryString}`
    );
    if (results.isSuccess) {
      setvehicleRegNumberArr(results.value);
      vehicleRegArr = results.value;
    }
    // setLoader(false);
    return;
  };
  /*./AXIOS Calls */

  const { height } = UseWindowDimensions();
  let dppr = 10;
  if (height > 700 && height < 900) {
    dppr = 15;
  } else if (height > 900) {
    dppr = 25;
  } else {
    dppr = 10;
  }
  const validationSchema = Yup.object().shape({
    registrationNumber: Yup.string().required("This field is required"),
    weBocId: Yup.string().max(50, "Maximum 50 characters allowed"),
    inspectorComments: Yup.string().max(3000, "Maximum 3000 characters allowed"),
    gdNo: Yup.string().max(50, "Maximum 50 characters are allowed"),
  });
  const formik = useFormik({
    initialValues: {
      id: 0,
      registrationNumber: "",
      gatePassId: 0,
      weBocId: "",
      webocRMSColorCode: 1,
      inspectorComments: "",
      yardSlotInfo: "",
      vehicleCleared: false,
      gdNo: "",
      filterBy: "today",
      startDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(0, 0)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      endDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(23, 59)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      InProgressVehiclesDataOnly: true,
    },
    validationSchema: validationSchema,
    onSubmit: async (values: any, actions) => {
      setLoader(true);
      // Add API here
      const res: any = !isEditMode
        ? await dispatch(createWebocInfo(values))
        : await dispatch(updateWebocInfo(values));

      if (res) {
        handleSearch();
        setisEditMode(false);
        actions.setSubmitting(false);
        actions.resetForm();
        setIsDirty(false);
      }
      setLoader(false);
    },
  });
  const { values, setValues } = formik;

  const handleSearch = async () => {
    const { filterBy, startDate, endDate, InProgressVehiclesDataOnly } = values;
    const body = {
      filterBy: filterBy || null,
      startDate: startDate || null,
      endDate: endDate || null,
      InProgressVehiclesDataOnly: InProgressVehiclesDataOnly,
    };
    setvehicleRecord([]);
    setLoader(true);
    // Add API here
    try {
      const results: any = await dispatch(searchData("/get-all-webocinfo", JSON.stringify(body)));
      if (results) {
        const transformedData = results.map((data: any, index: any) => {
          return data;
        });
        setvehicleRecord(transformedData);
      }
    } catch (error) {
      setLoader(false);
    }
    setLoader(false);
  };
  const resetSearch = () => {
    setValues({
      ...formik.initialValues,
      filterBy: values.filterBy,
      startDate: values.startDate,
      endDate: values.endDate,
      InProgressVehiclesDataOnly: values.InProgressVehiclesDataOnly,
    });
    setIsDirty(false);
    setisEditMode(false);
  };
  const [resetHandler, setResetHandler] = useState(false);

  const resetGrid = () => {
    setValues({
      ...formik.initialValues,
      id: values.id,
      registrationNumber: values.registrationNumber,
      gatePassId: values.gatePassId,
      weBocId: values.weBocId,
      webocRMSColorCode: values.webocRMSColorCode,
      inspectorComments: values.inspectorComments,
      yardSlotInfo: values.yardSlotInfo,
      vehicleCleared: values.vehicleCleared,
      gdNo: values?.gdNo,
    });
    setIsCustomDate(false);
    setResetHandler(true);
  };

  useEffect(() => {
    formik.setFieldValue("filterBy", "today");
    handleSearch();
    setResetHandler(false);
  }, [resetHandler]);

  const filterByAction = (data: any) => {
    formik.setFieldValue("filterBy", data.value);
    if (data && data.value) {
      const res = filterBy(data);
      if (res?.isCustomDate) {
        setIsCustomDate(true);
        formik.setFieldValue("startDateCustom", res?.startDate);
        formik.setFieldValue("endDateCustom", res?.endDate);
      } else {
        setIsCustomDate(false);
      }
      formik.setFieldValue("startDate", res?.startDate);
      formik.setFieldValue("endDate", res?.endDate);
    }
  };

  const handleUpdateClick = async (params: any) => {
    setisEditMode(true);
    formik.setFieldValue("registrationNumber", params.registrationNumber);

    formik.setFieldValue("id", params.id);
    formik.setFieldValue("gatePassId", params.gatePassId);
    formik.setFieldValue("weBocId", params.weBocId ?? "");
    formik.setFieldValue("webocRMSColorCode", params.webocRMSColorCode);
    formik.setFieldValue("inspectorComments", params.inspectorComments ?? "");
    formik.setFieldValue(
      "yardSlotInfo",
      params.yardName || params.rowName || params.slotNumber
        ? `${params.yardName || "-"}, Row ${params.rowName || "-"}, Slot ${
            params.slotNumber || "-"
          }`
        : ""
    );
    formik.setFieldValue("vehicleCleared", params.vehicleCleared);
    formik.setFieldValue("gdNo", params?.gdNumber ?? "");
  };
  useEffect(() => {
    if (vehicleRecord.length) {
      const transformedColumns: any = columns.map((column: any) =>
        column.accessorKey === "inspectorComments"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return (
                  <Tooltip title={renderedCellValue} followCursor>
                    <span>{renderedCellValue}</span>
                  </Tooltip>
                );
              },
            }
          : column.accessorKey === "registrationNumber"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return (
                  <>
                    <MuiLink
                      className="customMuiLink"
                      onClick={() => {
                        setisDrawerOpen(true);
                      }}
                    >
                      {row.original.registrationNumber ? row.original.registrationNumber : "-"}
                    </MuiLink>
                  </>
                );
              },
            }
          : column.accessorKey === "actionButtons"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return (
                  <>
                    <NewCommonButton
                      onClick={() => {
                        setIsDirty(true);
                        handleUpdateClick(row.original);
                      }}
                      icon={<EditIcon />}
                      isEdit={true}
                      disable={row.original.vehicleStatus === "Checked-out"}
                    >
                      Edit
                    </NewCommonButton>
                  </>
                );
              },
            }
          : column.accessorKey === "webocRMSColorCode"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return (
                  <div>
                    {
                      customColorCodeList.find((color: any) => color.value == renderedCellValue)
                        ?.name
                    }
                  </div>
                );
              },
            }
          : column.accessorKey === "vehicleCleared"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return (
                  <React.Fragment>
                    <Box>
                      <Tooltip title={row.original?.vehicleCleared ? "Yes" : "No"}>
                        <Button style={{ minWidth: "30px", padding: "4px", color: "gray" }}>
                          {row.original?.vehicleCleared ? <Check /> : <Close />}
                        </Button>
                      </Tooltip>
                    </Box>
                  </React.Fragment>
                );
              },
            }
          : column.accessorKey === "yardSlotInfo"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return (
                  <div>
                    {row.original.yardName || row.original.rowName || row.original.slotNumber
                      ? `${row.original.yardName || "-"}, Row ${
                          row.original.rowName || "-"
                        }, Slot ${row.original.slotNumber || "-"}`
                      : ""}
                  </div>
                );
              },
            }
          : column
      );

      setDisplayColumns(transformedColumns);
    }
  }, [vehicleRecord]);

  // Show prompt if the form is fully or partially filled and user wants to navigate away
  const [isDirty, setIsDirty] = React.useState<boolean>(false);
  useEffect(() => {
    // If prompt, when reloading or closing the tab
    window.onbeforeunload = function (e: Event) {
      if (isDirty) {
        e.preventDefault();
        return "Changes you made may not be saved.";
      }
    };
  }, [isDirty]);

  function handleChange(e: any) {
    // Textfield ==>> e.target.value
    // Checkbox / Switch ==>> e.target.checked !== e.target._wrapperState.initialChecked
    formik.handleChange(e);
    e.target.value || JSON.stringify(formik.values) !== JSON.stringify(formik.initialValues)
      ? setIsDirty(true)
      : setIsDirty(false);
  }

  const [isDrawerOpen, setisDrawerOpen] = React.useState(false);
  const handleCloseDrawer = () => {
    setisDrawerOpen(false);
  };

  const listener = (e: any) => {
    if (
      (e.key === "s" || e.key === "S") &&
      (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)
    ) {
      e.preventDefault();
      formik.submitForm();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, []);

  return (
    <div>
      {/* If prompt, when navigating to another page inside the app */}
      <Prompt when={isDirty} message="Changes you made may not be saved." />
      <TabHeader module={moduleName} heading={pageHeading} link={OthersRoute.path} />
      <Backdrop className={classes.backdrop} open={loader2 || loading}>
        <CommonLoader />
      </Backdrop>
      <Drawer
        isDrawerOpen={isDrawerOpen}
        handleCloseDrawer={() => {
          handleCloseDrawer();
        }}
      />
      <Box m={2} />
      <Card>
        <CardContent className={classes.cardMain}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item md={9}>
              <Box mt={1} mb={2}>
                <Typography className={classes.pageHeading}> {pageHeading} </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={3} direction="row">
              <Box textAlign="right" mt={1} mb={1}>
                <CommonButton cssClass="customSubmitBtn" onClick={() => resetSearch()}>
                  Reset
                </CommonButton>
                <CommonButton
                  cssClass="customSubmitBtn"
                  isGreen
                  onClick={() => formik.submitForm()}
                >
                  Update
                  {/* {isEditMode ? "Update" : "Save"} */}
                </CommonButton>
              </Box>
            </Grid>
          </Grid>
          <Box style={{ marginBottom: "30px" }}>
            <Divider />
          </Box>
          <>
            <Grid spacing={2} container direction="row">
              {/* Vehicle Number */}
              <Grid item xs={12} md={4}>
                <Box style={{ display: isEditMode ? "none" : "block" }}>
                  <CommonAutoCompleteField
                    cssClassName="customTextField"
                    label="Vehicle Number"
                    placeholder="Select Vehicle Number"
                    name="registrationNumber"
                    optionsType={vehicleRegNumberArr}
                    getOptionLabel={(option) => option.registrationNumber}
                    required
                    value={
                      vehicleRegNumberArr.find(
                        (st: any) => st.registrationNumber === formik.values.registrationNumber
                      ) || null
                    }
                    onChange={(option: any) => {
                      if (option && option.registrationNumber !== "" && option.vehicleId !== 0) {
                        getVehicleInfoByVehicleId(option.vehicleId, option.registrationNumber);
                        formik.setFieldValue("gatePassId", option.gatePassId);
                        handleChange({ target: { value: option.vehicleId } });
                        getVehicleStatus(option.gatePassId);
                      } else {
                        formik.setFieldValue("registrationNumber", "");
                        formik.setFieldValue("gatePassId", "");
                        handleChange({ target: { value: null } });
                      }
                    }}
                    onKeyUp={(e: any) => {
                      setVehicleNumberLength(e.target.value.length);
                      setVehicleNumber(e.target.value);

                      if (e.target.value.length == 2 && vehicleNumberLength < 2) {
                        getVehicleByRegistrationNo(e.target.value);
                        return;
                      }
                    }}
                    onKeyDownCapture={(e: any) => {
                      if (/[^A-Za-z0-9\d]/.test(e.key)) e.preventDefault();
                      else handleChange(e);
                    }}
                    onPaste={(e: any) => {
                      if (/[^A-Za-z0-9\d]/.test(e.clipboardData.getData("text"))) {
                        e.preventDefault();
                        return;
                      }

                      if (e.clipboardData.getData("text").length >= 2)
                        getVehicleByRegistrationNo(e.clipboardData.getData("text"));
                    }}
                    error={
                      formik.touched.registrationNumber && Boolean(formik.errors.registrationNumber)
                    }
                    helperText={
                      formik.touched.registrationNumber && formik.errors.registrationNumber
                    }
                  />
                </Box>
                <Box style={{ display: isEditMode ? "block" : "none" }}>
                  <TextField
                    className={"customTextField"}
                    required
                    size="small"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Vehicle Number"
                    name="registrationNumber"
                    id="registrationNumber"
                    placeholder="Enter Vehicle Number"
                    disabled={true}
                    value={formik.values.registrationNumber}
                    error={
                      formik.touched.registrationNumber && Boolean(formik.errors.registrationNumber)
                    }
                    helperText={
                      formik.touched.registrationNumber && formik.errors.registrationNumber
                    }
                  />
                </Box>
              </Grid>
              {/* IGM # */}
              <Grid item xs={12} md={4}>
                <Box>
                  <TextField
                    className="customTextField"
                    size="small"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="WeBOC ID (IGM#)"
                    name="weBocId"
                    placeholder="Enter Reference Number"
                    disabled={false}
                    value={formik.values.weBocId}
                    onChange={handleChange}
                    error={formik.touched.weBocId && Boolean(formik.errors.weBocId)}
                    helperText={formik.touched.weBocId && formik.errors.weBocId}
                  />
                </Box>
              </Grid>
              {/* WeBOC RMS Color Code */}
              <Grid item xs={12} md={4}>
                <CommonSelect
                  cssClassName="customTextField"
                  inputLabel="WeBOC RMS Color Code"
                  name="webocRMSColorCode"
                  allValues={customColorCodeList}
                  value={formik.values.webocRMSColorCode}
                  onChange={(event: SelectChangeEvent) => {
                    formik.setFieldValue("webocRMSColorCode", event?.target?.value);
                  }}
                />
              </Grid>
              {/* Custom Inspector Remarks */}
              <Grid item xs={12} md={4}>
                <Box>
                  <TextField
                    size="small"
                    fullWidth
                    className="customTextField"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Good’s Declaration Number (GD#)"
                    name="gdNo"
                    id="gdNo"
                    placeholder="Enter GD#"
                    disabled={false}
                    value={formik.values.gdNo}
                    onChange={handleChange}
                    // onPaste={(e: any) => {
                    //   if (/[^A-Za-z0-9 ]/.test(e.clipboardData.getData("text")))
                    //     e.preventDefault();
                    // }}
                    // onKeyDownCapture={(e: any) => {
                    //   if (/[^A-Za-z0-9 ]/.test(e.key)) e.preventDefault();
                    // }}
                    error={formik.touched.gdNo && Boolean(formik.errors.gdNo)}
                    helperText={formik.touched.gdNo && formik.errors.gdNo}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box>
                  <TextField
                    multiline
                    rows={1}
                    rowsMax={8}
                    className="customTextField"
                    size="small"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Customs Inspector Remarks"
                    name="inspectorComments"
                    placeholder="Enter Remarks"
                    disabled={false}
                    value={formik.values.inspectorComments}
                    onChange={handleChange}
                    error={
                      formik.touched.inspectorComments && Boolean(formik.errors.inspectorComments)
                    }
                    helperText={formik.touched.inspectorComments && formik.errors.inspectorComments}
                  />
                </Box>
              </Grid>
              {/* Yard Slot Info */}
              <Grid item xs={12} md={4}>
                <Box>
                  <TextField
                    className="customTextField"
                    size="small"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Yard Slot Info"
                    name="yardSlotInfo"
                    disabled={true}
                    value={formik.values.yardSlotInfo}
                  />
                </Box>
              </Grid>
              {/* Vehicle Cleared or not */}
              <Grid item xs={12} md={4}>
                <Box>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={Boolean(formik.values.vehicleCleared)}
                        onChange={formik.handleChange}
                        name="vehicleCleared"
                        color="primary"
                      />
                    }
                    label="Vehicle Cleared"
                  />
                </Box>
              </Grid>
            </Grid>
          </>
          <Box style={{ marginTop: "30px", marginBottom: "30px" }}>
            <Divider />
          </Box>
          <>
            <Grid spacing={2} container direction="row">
              <Grid item xs={12} md={4} lg={2}>
                <CommonAutoCompleteField
                  cssClassName="customTextField"
                  error={formik.touched.filterBy && Boolean(formik.errors.filterBy)}
                  helperText={formik.touched.filterBy && formik.errors.filterBy}
                  label="Filter by"
                  placeholder="Filter by"
                  name="filterBy"
                  disableClearable={true}
                  optionsType={filteryByArr}
                  getOptionLabel={(option: any) => option.label || null}
                  onChange={(row: any) => {
                    row ? setValues({ ...values, filterBy: row.value || "" }) : "";
                    if (row === null) {
                      formik.setFieldValue("filterBy", null);
                    }
                    filterByAction(row);
                  }}
                  value={
                    filteryByArr.find(({ value }: any) => value === formik.values.filterBy) || ""
                  }
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
                lg={2}
                className={!isCustomDate ? classes.hideDatesGrid : ""}
              >
                <CommonTextFieldDate
                  cssClassName="customTextField"
                  label={"Start Date"}
                  name={"startDate"}
                  datePickerRef={startDatePickerRef}
                  value={formik.values.startDate}
                  onChange={(e: any) => {
                    formik.setFieldValue("startDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                    formik.setFieldValue("endDate", "");
                  }}
                  maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
                lg={2}
                className={!isCustomDate ? classes.hideDatesGrid : ""}
              >
                <CommonTextFieldDate
                  cssClassName="customTextField"
                  label={"End Date"}
                  name={"endDate"}
                  datePickerRef={endDatePickerRef}
                  value={formik.values.endDate}
                  onChange={(e: any) => {
                    formik.setFieldValue("endDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                  }}
                  minDate={formik.values.startDate}
                  maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={2}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={Boolean(formik.values.InProgressVehiclesDataOnly)}
                      onChange={formik.handleChange}
                      name="InProgressVehiclesDataOnly"
                      color="primary"
                    />
                  }
                  label="In Progress Vehicles"
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={isCustomDate ? 8 : 4}
                lg={isCustomDate ? 4 : 8}
                direction="row"
                style={{ float: "right" }}
              >
                <Box textAlign="right" mt={1} mb={1}>
                  <CommonButton cssClass="customSubmitBtn" onClick={() => resetGrid()}>
                    Reset
                  </CommonButton>
                  <CommonButton cssClass="customSubmitBtn" isGreen onClick={handleSearch}>
                    Search
                  </CommonButton>
                </Box>
              </Grid>
            </Grid>
          </>
          <div className="">
            <CommonMaterialGrid
              rows={vehicleRecord}
              columns={displayColumns}
              defaultPerPageRecord={15}
              height={550}
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
